export function isVideoMime(mimeType: string): boolean {
  return mimeType.startsWith("video/");
}

export function formatDate(value: string | Date): string {
  return new Intl.DateTimeFormat("sv-SE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(value));
}

export function formatDateTime(value: string | Date): string {
  const date = new Date(value);
  const time = new Intl.DateTimeFormat("sv-SE", {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(date);
  return `${formatDate(date)} ${time}`;
}
